const PATH = 'fe.pages.learning_resources.detail_page';

const messages = {
  time: {
    key: `${PATH}.time`,
    defaultValue: 'Estimated Time:'
  },
  dimensions: {
    key: `${PATH}.dimensions`,
    defaultValue: 'Dimensions:'
  },
  instructions: {
    key: `${PATH}.instructions`,
    defaultValue: 'Instructions:'
  },
  indicators: {
    key: `${PATH}.indicators`,
    defaultValue: 'Indicators:'
  },
  description: {
    key: `${PATH}.description`,
    defaultValue: 'Resource Description:'
  },
  goals: {
    key: `${PATH}.goals`,
    defaultValue: 'Learning Goals:'
  },
  back: {
    key: `${PATH}.back`,
    defaultValue: 'Back'
  },
  home: {
    key: `${PATH}.home`,
    defaultValue: 'Home'
  },
  noSubscription: {
    key: `${PATH}.no_subscription`,
    defaultValue:
      'You do not have access to this Learning Resources subscription.'
  },
  playlist: {
    resourcesCount: {
      key: `${PATH}.resources_count`,
      defaultValue: '{{count}} Resources'
    },
    subtitle: {
      key: `${PATH}.subtitle`,
      defaultValue: 'Learning Series'
    }
  }
};

export default messages;
